import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';
import { useAccountsOptionsQuery } from '../../../../../../api/useAccountsOptionsQuery';

export const AccountNickname = () => {
  const formBag = useFormContext();
  const { data } = useAccountsOptionsQuery();
  const { ShowAccountNickname: showAccountNickname = false } = data?.Options || {};

  if (!showAccountNickname) {
    return null;
  }

  return (
    <Input
      {...formBag.register('bankAccount.AccountNickname')}
      label="Account Nickname"
      maxLength={50}
    />
  );
};
